import React, { ChangeEvent } from 'react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBug } from '@fortawesome/pro-solid-svg-icons'
import { FusionColor } from '../../../theme/FusionStyle'

const CheckboxUnchecked = () => (
	<svg width="20" height="20" viewBox="0 0 20 20">
		<g fill="#fff" stroke="#4f5765" strokeWidth="1">
			<rect width="20" height="20" rx="5" stroke="none" />
			<rect x="0.5" y="0.5" width="19" height="19" rx="4.5" fill="none" />
		</g>
	</svg>

)

const CheckboxChecked = () => (
	<svg width="20" height="20" viewBox="0 0 20 20">
		<rect width="20" height="20" rx="5" fill="currentColor" />
		<path d="M13.706-10.706a1,1,0,0,1,0,1.416l-8,8a1,1,0,0,1-1.416,0l-4-4a1,1,0,0,1,0-1.416,1,1,0,0,1,1.416,0L5-3.416l7.294-7.291a1,1,0,0,1,1.416,0Z" transform="translate(3 16)" fill="#fff" />
	</svg>
)

const RadioUnchecked = () => (
	<svg width="20" height="20" viewBox="0 0 20 20">
		<g fill="#fff" stroke="#4f5765" strokeWidth="1">
			<circle cx="10" cy="10" r="10" stroke="none"/>
			<circle cx="10" cy="10" r="9.5" fill="none"/>
		</g>
	</svg>
)

const RadioChecked = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<circle cx="10" cy="10" r="10" fill="currentColor" />
		<circle cx="4" cy="4" r="4" transform="translate(6 6)" fill="#fff" />
	</svg>
)

interface L1BooleanRootProps {
	color?: FusionColor
	label?: string
	disabled: boolean
}

const L1BooleanRoot = styled.label<L1BooleanRootProps>(({theme, color, label, disabled}) => ({
	display: 'grid',
	gridTemplateColumns: `min-content auto`,
	alignItems: 'center',
	columnGap: (label && label !== '') ? theme.spacing(1) : 0,
	cursor: disabled ? 'default' : 'pointer',
	color: color ? theme.colors[color] : 'inherit',
	opacity: disabled ? theme.disabledOpacity : 1,
}))

interface L1BooleanControlContainerProps {
	color?: FusionColor,
	checked: boolean,
	disabled: boolean,
}

const L1BooleanControlContainer = styled.div<L1BooleanControlContainerProps>(({theme, color, disabled}) => ({
	// TODO
	// color should be based on valueTypes.js
	color: color ? theme.colors[color] : theme.colors.blueMain,
	fontSize: '20px',
	width: '24px',
	height: '24px',
	overflow: 'hidden',
	position: 'relative',
	// border: '1px solid fuchsia',
	'> input': {
		margin: 0,
		width: '24px',
		height: '24px',
		cursor: disabled ? 'default' : 'pointer',
		opacity: 0,
	},
	'> svg': {
		position: 'absolute',
		top: '1px',
		left: '2px',
		pointerEvents: 'none',
	},
}))

interface L1BooleanProps {
	inputType: string
	name?: string
	color?: FusionColor
	label?: string
	checked?: boolean
	disabled?: boolean
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void
	dataCid?: string
}

const L1Boolean = ({inputType, name, color, label, checked = false, disabled = false, onChange, dataCid}: L1BooleanProps) => {
	const inputProps = {
		type: inputType,
		checked,
		disabled,
		onChange,
		name: name ?? undefined
	}
	let input, icon
	switch(inputType) {
		case 'checkbox':
			input = <input {...inputProps} />
			icon = checked ? <CheckboxChecked /> : <CheckboxUnchecked />
			break
		case 'radio':
			input = <input {...inputProps} />
			icon = checked ? <RadioChecked /> : <RadioUnchecked />
			break
		default:
			icon = <FontAwesomeIcon fixedWidth icon={faBug} />
	}
	return (
		<L1BooleanRoot data-cid={dataCid} color={color} label={label} disabled={disabled}>
			<L1BooleanControlContainer color={color} checked={checked} disabled={disabled}>
				{input}
				{icon}
			</L1BooleanControlContainer>
			{label}
		</L1BooleanRoot>
	)
}

export default L1Boolean
